import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import { customRound } from "../../../../utils/nutrition-util";

const MasterFoodLibraryTable = ({ data = [] }) => {
  const { t } = useTranslation("coaching-portal");
  const ns = "masterFoodLibraryScreen.table";

  /**
   * Open edit modal
   */
  const handleOpenModal = (_id) => {
    const body = { "modal[type]": "handle-meal-planner-food", foodId: _id };

    submit(`/actions/refresh/?`, {
      method: "GET",
      body,
    });
  };

  /**
   * Delete food
   * @param {*} e
   * @param {*} _id
   */
  const deleteFood = (e, _id) => {
    e.preventDefault();

    submit(`/actions/meal-planner/delete-master-food-library/${_id}/food`, {
      method: "GET",
    });
  };

  return (
    <section className="meal-table" data-scrollable="true" role="table-wrapper">
      <table>
        <thead>
          <tr>
            <th className="big">{t(`${ns}.foodName`)}</th>
            <th className="medium">{t(`${ns}.brandName`)}</th>
            <th className="medium">{t(`${ns}.quantity`)}</th>
            <th className="medium">{t(`${ns}.measurements`)}</th>
            <th className="small">{t(`${ns}.proteins`)}</th>
            <th className="small">{t(`${ns}.carbs`)}</th>
            <th className="small">{t(`${ns}.fats`)}</th>
            <th className="small">{t(`${ns}.fibers`)}</th>
            <th className="medium">{t(`${ns}.kCal`)}</th>
            <th className="medium">{t(`${ns}.actions`)}</th>
          </tr>
        </thead>
        <tbody>
          {data.map(
            ({
              brand = "",
              name = "",
              calories = 0,
              carbs = 0,
              fats = 0,
              fibers = 0,
              measurementsValue = 1,
              proteins = 0,
              quantityDescription = "serving",
              quantityNumber = 1,
              unitOfMeasure = "g",
              _id,
            }) => (
              <tr key={_id}>
                <td>{name}</td>
                <td>{brand}</td>
                <td>
                  {quantityNumber} {quantityDescription}
                </td>
                <td>
                  {customRound(measurementsValue)} {unitOfMeasure}
                </td>
                <td>{proteins}</td>
                <td>{carbs}</td>
                <td>{fats}</td>
                <td>{fibers}</td>
                <td>{calories}</td>
                <td>
                  <div className="actions">
                    <button
                      data-button-type="outline"
                      onClick={() => handleOpenModal(_id)}
                    >
                      <span>{t(`${ns}.edit`)}</span>
                    </button>
                    <button data-button-type="secondary" data-icon-only>
                      <SvgIcon
                        src="/img/new-icons/red-trash.svg"
                        onClickFn={(e) => deleteFood(e, _id)}
                        noFilterOnLight={true}
                      />
                    </button>
                  </div>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </section>
  );
};

MasterFoodLibraryTable.propTypes = {
  data: PropTypes.array,
};

export default MasterFoodLibraryTable;
